var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7823 72.522H7.08594",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2617 72.522H42.7397",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1739 24.8408H11.4348C10.051 24.8408 8.724 25.3791 7.74555 26.3371C6.7671 27.2952 6.21739 28.5946 6.21739 29.9495V72.522H1V74.2249L6.21739 79.3336H75.7826L81 74.2249V72.522H46.218",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7832 72.5221V58.8989",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8696 14.623H77.5217C78.4442 14.623 79.3289 14.9819 79.9812 15.6206C80.6335 16.2593 81 17.1256 81 18.0288V50.3839C81 51.2872 80.6335 52.1535 79.9812 52.7922C79.3289 53.4309 78.4442 53.7897 77.5217 53.7897H65.3478V65.71H63.6087L53.1739 53.7897H44.4783C43.5558 53.7897 42.6711 53.4309 42.0188 52.7922C41.3665 52.1535 41 51.2872 41 50.3839V18.0288C41 17.1256 41.3665 16.2593 42.0188 15.6206C42.6711 14.9819 43.5558 14.623 44.4783 14.623H51.5447",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2173 40.1667H53.1738C54.0963 40.1667 54.981 39.8078 55.6333 39.1691C56.2856 38.5304 56.6521 37.6641 56.6521 36.7609V4.4058C56.6521 3.50252 56.2856 2.63624 55.6333 1.99753C54.981 1.35882 54.0963 1 53.1738 1H16.6521C15.7296 1 14.8449 1.35882 14.1926 1.99753C13.5403 2.63624 13.1738 3.50252 13.1738 4.4058V36.7609C13.1738 37.6641 13.5403 38.5304 14.1926 39.1691C14.8449 39.8078 15.7296 40.1667 16.6521 40.1667H21.8695V52.087H23.6086L34.0434 40.1667",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIco);
export default __webpack_public_path__ + "static/media/notification-ico.3d4a1c89aff6d23bee5bfee690355255.svg";
export { ForwardRef as ReactComponent };